var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPagenotfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 512,
    viewBox: "0 0 518 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M454.306 438.668C443.754 449.642 433.77 456.719 425.881 462.311C333.156 528.036 223.438 508.877 200.12 504.199C165.686 497.29 99.1263 483.935 51.005 428.03C-21.7986 343.452 -10.462 210.201 46.0095 122.24C56.339 106.15 110.902 16.8491 221.802 2.52816C288.918 -6.13877 367.153 11.3414 423.809 58.2328C542.734 156.662 534.268 355.506 454.306 438.668Z",
    fill: "url(#paint0_linear_991_1197)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211.843 470.256C208.6 411.806 186.923 358.486 109.966 320.554C109.966 320.554 98.0215 463.936 211.843 470.256Z",
    fill: "#BDD0FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M190.71 444.882C190.554 444.882 190.398 444.824 190.278 444.707C146.749 402.224 119.554 339.899 119.284 339.274C119.149 338.96 119.293 338.596 119.607 338.46C119.919 338.325 120.286 338.469 120.421 338.783C120.69 339.405 147.793 401.512 191.142 443.82C191.387 444.059 191.392 444.451 191.153 444.696C191.032 444.82 190.871 444.882 190.71 444.882Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M346.003 466.608C398.563 471.459 448.989 459.189 493.016 395.578C493.016 395.578 366.718 365.93 346.003 466.608Z",
    fill: "#BDD0FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M375.825 449.437C375.683 449.437 375.541 449.389 375.425 449.29C375.164 449.069 375.132 448.678 375.353 448.417C391.066 429.896 416.792 418.128 435.607 411.516C455.965 404.363 472.848 401.537 473.016 401.51C473.357 401.449 473.672 401.682 473.727 402.019C473.783 402.357 473.555 402.675 473.218 402.731C472.549 402.842 406.045 414.154 376.298 449.218C376.175 449.363 376.001 449.437 375.825 449.437Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.937 355.836L206.886 454.95H335.101L318.4 355.836H217.937Z",
    fill: "url(#paint1_linear_991_1197)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55859 111.643V338.638C2.55859 357.311 17.439 372.582 36.1063 373.063C119.016 375.201 408.994 380.385 487.918 379.221C501.484 379.021 512.472 368.166 512.864 354.605C514.386 301.871 516.857 175.064 507.711 116.192C505.784 103.794 495.319 94.5232 482.779 94.1222C413.311 91.8997 105.916 84.8432 27.028 86.6149C13.4225 86.92 2.55859 98.0337 2.55859 111.643Z",
    fill: "url(#paint2_linear_991_1197)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8027 110.538V326.199C16.8027 337.101 25.5544 345.985 36.4558 346.148L476.565 351.585C487.373 351.747 496.232 343.052 496.272 332.243L497.008 118.508C497.037 110.78 490.88 104.447 483.153 104.259L32.5635 95.156C23.9217 94.9457 16.8027 101.894 16.8027 110.538Z",
    fill: "#E7EDF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M499.585 360.433C499.581 360.433 499.578 360.433 499.574 360.433L16.7917 352.207C16.4494 352.201 16.1767 351.919 16.1827 351.577C16.1894 351.235 16.5002 350.963 16.8122 350.968L499.595 359.194C499.937 359.2 500.21 359.482 500.204 359.824C500.198 360.163 499.922 360.433 499.585 360.433Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M262.956 370.479C259.845 370.479 257.313 367.948 257.313 364.837C257.313 361.725 259.845 359.194 262.956 359.194C266.067 359.194 268.599 361.726 268.599 364.837C268.599 367.948 266.067 370.479 262.956 370.479ZM262.956 360.433C260.527 360.433 258.552 362.408 258.552 364.837C258.552 367.265 260.528 369.241 262.956 369.241C265.385 369.241 267.36 367.265 267.36 364.837C267.36 362.408 265.385 360.433 262.956 360.433Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M338.271 469.358C394.65 441.371 438.144 397.345 442.996 305.221C442.996 305.221 296.256 354.212 338.271 469.358Z",
    fill: "#7D97F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M347.39 448.563C347.322 448.563 347.253 448.552 347.185 448.528C346.862 448.414 346.692 448.061 346.806 447.738C360.264 409.373 380.264 379.793 394.673 361.733C410.289 342.159 422.901 331.51 423.027 331.405C423.29 331.187 423.68 331.221 423.9 331.482C424.119 331.743 424.085 332.134 423.823 332.354C423.324 332.773 373.612 375.061 347.974 448.148C347.885 448.403 347.646 448.563 347.39 448.563Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M362.719 475.229H175.068C169.97 475.229 166.141 471.599 167.127 467.701L169.535 458.178C170.259 455.315 173.409 453.212 177.152 453.095L358.054 447.45C361.964 447.329 365.425 449.404 366.277 452.38L370.618 467.547C371.746 471.488 367.899 475.229 362.719 475.229Z",
    fill: "url(#paint3_linear_991_1197)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M276.084 455.683C275.746 455.683 275.47 455.411 275.465 455.072C275.46 454.73 275.733 454.449 276.075 454.444L283.827 454.331C283.83 454.331 283.833 454.331 283.836 454.331C284.174 454.331 284.451 454.603 284.455 454.941C284.46 455.284 284.187 455.565 283.845 455.57L276.093 455.683C276.09 455.683 276.087 455.683 276.084 455.683Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M174.075 469.986C174.043 469.986 174.009 469.984 173.977 469.978C173.639 469.924 173.409 469.607 173.463 469.269L174.569 462.343C175.163 458.618 178.333 455.874 182.105 455.818L264.326 454.616C264.33 454.616 264.332 454.616 264.336 454.616C264.674 454.616 264.95 454.887 264.955 455.226C264.96 455.568 264.686 455.849 264.345 455.854L182.124 457.056C178.954 457.103 176.292 459.408 175.792 462.538L174.686 469.464C174.637 469.769 174.374 469.986 174.075 469.986Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M409.247 18.6309C412.053 18.7637 414.885 19.0208 417.663 19.394C418.044 19.4451 418.416 19.4114 418.762 19.3072C419.711 19.021 420.454 18.2028 420.595 17.1557C420.787 15.7282 419.785 14.4148 418.357 14.2229C415.432 13.8301 412.45 13.5599 409.495 13.42C408.055 13.3519 406.833 14.4632 406.766 15.9024C406.697 17.3408 407.809 18.5625 409.247 18.6309Z",
    fill: "url(#paint4_linear_991_1197)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M336.169 42.2936C335.171 41.2533 333.521 41.218 332.48 42.2152C330.348 44.259 328.278 46.4202 326.328 48.6368C325.376 49.7186 325.482 51.3663 326.563 52.3184C327.266 52.9366 328.207 53.108 329.042 52.8564C329.492 52.7205 329.912 52.4621 330.245 52.0828C332.098 49.9764 334.065 47.9242 336.09 45.9818C337.13 44.9845 337.165 43.3329 336.169 42.2936Z",
    fill: "url(#paint5_linear_991_1197)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M304.18 101.244C302.754 101.051 301.439 102.05 301.244 103.477C300.845 106.405 300.57 109.385 300.425 112.334C300.354 113.773 301.464 114.997 302.902 115.068C303.209 115.083 303.506 115.045 303.784 114.961C304.81 114.651 305.58 113.723 305.636 112.591C305.773 109.79 306.035 106.961 306.413 104.18C306.608 102.753 305.608 101.438 304.18 101.244Z",
    fill: "url(#paint6_linear_991_1197)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M321.172 59.373C319.969 58.579 318.351 58.9118 317.559 60.1149C315.93 62.5839 314.39 65.1492 312.98 67.7379C312.291 69.0027 312.758 70.5869 314.024 71.2759C314.662 71.6232 315.38 71.6769 316.025 71.4824C316.658 71.2912 317.22 70.8598 317.562 70.2321C318.902 67.7717 320.366 65.3335 321.914 62.987C322.707 61.7837 322.375 60.1661 321.172 59.373Z",
    fill: "url(#paint7_linear_991_1197)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M387.151 20.0765C389.917 19.5818 392.735 19.199 395.527 18.941C395.705 18.9246 395.877 18.8897 396.042 18.8398C397.205 18.489 398 17.3585 397.884 16.1027C397.751 14.6685 396.481 13.6128 395.046 13.7457C392.108 14.0178 389.142 14.4207 386.232 14.941C384.811 15.1886 383.87 16.5504 384.123 17.9685C384.377 19.386 385.732 20.3299 387.151 20.0765Z",
    fill: "url(#paint8_linear_991_1197)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M310.327 79.3515C308.979 78.845 307.475 79.5264 306.966 80.8729C305.925 83.637 304.991 86.4807 304.188 89.3248C303.798 90.7112 304.605 92.1525 305.991 92.5431C306.487 92.683 306.99 92.6698 307.45 92.5311C308.275 92.2822 308.959 91.6313 309.21 90.741C309.971 88.0381 310.86 85.3372 311.848 82.7123C312.356 81.3642 311.675 79.8593 310.327 79.3515Z",
    fill: "url(#paint9_linear_991_1197)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M303.085 123.945C301.646 124.08 300.593 125.344 300.723 126.779C300.988 129.712 301.384 132.677 301.9 135.591C302.151 137.009 303.505 137.956 304.924 137.705C305.026 137.686 305.127 137.662 305.225 137.633C306.473 137.256 307.271 135.997 307.038 134.682C306.547 131.913 306.17 129.096 305.918 126.308C305.789 124.874 304.52 123.816 303.085 123.945Z",
    fill: "url(#paint10_linear_991_1197)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M345.851 37.5875C346.121 37.5062 346.382 37.3785 346.624 37.2045C348.898 35.5638 351.27 34.002 353.677 32.5632C354.914 31.8231 355.316 30.2211 354.577 28.985C353.837 27.748 352.238 27.3521 350.999 28.0857C348.465 29.6014 345.966 31.246 343.572 32.9739C342.404 33.8168 342.14 35.447 342.983 36.6158C343.651 37.5424 344.815 37.8999 345.851 37.5875Z",
    fill: "url(#paint11_linear_991_1197)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M365.651 26.4572C365.74 26.4307 365.828 26.3988 365.915 26.3628C368.497 25.2732 371.16 24.2805 373.831 23.413C375.202 22.9687 375.952 21.4974 375.507 20.1266C375.068 18.7744 373.629 18.0261 372.274 18.4347C372.256 18.44 372.238 18.4455 372.221 18.4518C369.408 19.3641 366.605 20.4088 363.887 21.5552C362.56 22.1161 361.938 23.6459 362.498 24.9735C363.021 26.2129 364.391 26.8373 365.651 26.4572Z",
    fill: "url(#paint12_linear_991_1197)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M310.337 147.97C309.9 146.615 308.449 145.829 307.092 146.238C307.075 146.243 307.059 146.248 307.043 146.253C305.664 146.669 304.929 148.2 305.372 149.572C306.281 152.39 307.343 155.276 308.484 157.993C309.005 159.235 310.371 159.84 311.633 159.459C311.719 159.433 311.794 159.361 311.879 159.325C313.208 158.767 313.835 157.246 313.277 155.918C312.195 153.337 311.2 150.648 310.337 147.97Z",
    fill: "url(#paint13_linear_991_1197)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M438.35 21.6874C438.796 20.3183 438.046 18.8459 436.677 18.4001C435.331 17.962 433.955 17.5448 432.584 17.16C431.197 16.7676 429.756 17.5776 429.367 18.9649C428.977 20.3513 429.785 21.792 431.172 22.1816C432.475 22.5485 433.783 22.9445 435.062 23.3613C435.588 23.5325 436.129 23.5268 436.62 23.3786C437.41 23.1404 438.075 22.5322 438.35 21.6874Z",
    fill: "url(#paint14_linear_991_1197)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M394.832 216.036C392.084 215.767 389.314 215.376 386.6 214.876C385.182 214.614 383.823 215.551 383.562 216.968C383.301 218.385 384.238 219.745 385.654 220.006C388.512 220.533 391.429 220.944 394.323 221.228C394.672 221.262 395.013 221.226 395.33 221.131C396.312 220.835 397.067 219.97 397.173 218.887C397.314 217.453 396.266 216.176 394.832 216.036Z",
    fill: "url(#paint15_linear_991_1197)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M502.456 78.7847C503.023 79.9535 504.348 80.5075 505.553 80.144C505.685 80.1043 505.815 80.0545 505.942 79.9926C507.238 79.3634 507.779 77.8029 507.15 76.5068C506.532 75.233 505.876 73.9503 505.202 72.6957C504.52 71.427 502.944 70.9481 501.669 71.6326C500.4 72.3143 499.924 73.8958 500.606 75.1653C501.247 76.3567 501.869 77.5748 502.456 78.7847Z",
    fill: "url(#paint16_linear_991_1197)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M514.309 109.792C512.88 109.932 511.826 111.207 511.966 112.641C512.233 115.391 512.386 118.182 512.421 120.939C512.439 122.379 513.621 123.532 515.062 123.514C515.313 123.511 515.555 123.473 515.783 123.404C516.868 123.077 517.652 122.062 517.637 120.873C517.601 117.971 517.44 115.032 517.158 112.137C517.019 110.702 515.743 109.652 514.309 109.792Z",
    fill: "url(#paint17_linear_991_1197)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M514.574 132.165C513.147 131.985 511.841 132.999 511.661 134.428C511.317 137.165 510.851 139.922 510.275 142.626C509.976 144.035 510.874 145.42 512.283 145.72C512.729 145.814 513.171 145.789 513.578 145.666C514.459 145.401 515.173 144.676 515.378 143.711C515.984 140.866 516.475 137.961 516.837 135.078C517.017 133.649 516.004 132.344 514.574 132.165Z",
    fill: "url(#paint18_linear_991_1197)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M496.964 175.173C495.485 177.501 493.887 179.798 492.216 181.998C491.345 183.145 491.568 184.782 492.716 185.653C493.407 186.178 494.276 186.305 495.048 186.072C495.558 185.919 496.024 185.609 496.37 185.153C498.129 182.838 499.81 180.422 501.368 177.971C502.14 176.755 501.781 175.143 500.565 174.37C499.347 173.597 497.736 173.956 496.964 175.173Z",
    fill: "url(#paint19_linear_991_1197)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M466.339 205.763C464.003 207.24 461.578 208.633 459.132 209.902C457.854 210.567 457.356 212.141 458.02 213.42C458.607 214.551 459.907 215.071 461.085 214.716C461.238 214.67 461.39 214.609 461.537 214.533C464.112 213.195 466.666 211.729 469.127 210.173C470.344 209.404 470.708 207.793 469.938 206.574C469.168 205.357 467.558 204.995 466.339 205.763Z",
    fill: "url(#paint20_linear_991_1197)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M483.338 192.167C481.383 194.122 479.324 196.013 477.219 197.789C476.117 198.718 475.978 200.365 476.907 201.466C477.599 202.286 478.689 202.572 479.655 202.281C479.986 202.181 480.302 202.014 480.583 201.777C482.8 199.907 484.967 197.915 487.026 195.857C488.045 194.839 488.045 193.188 487.028 192.169C486.009 191.149 484.357 191.149 483.338 192.167Z",
    fill: "url(#paint21_linear_991_1197)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M509.907 154.045C508.55 153.555 507.056 154.257 506.567 155.612C505.631 158.206 504.571 160.795 503.418 163.308C502.817 164.618 503.392 166.166 504.701 166.767C505.303 167.043 505.954 167.071 506.541 166.894C507.233 166.685 507.835 166.191 508.16 165.484C509.373 162.839 510.488 160.114 511.474 157.384C511.963 156.029 511.262 154.534 509.907 154.045Z",
    fill: "url(#paint22_linear_991_1197)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M425.546 220.32C422.801 220.661 420.012 220.89 417.257 221C415.819 221.052 414.697 222.27 414.754 223.71C414.811 225.148 416.024 226.269 417.464 226.212C420.365 226.097 423.301 225.856 426.189 225.497C426.339 225.479 426.484 225.447 426.623 225.405C427.818 225.045 428.615 223.867 428.456 222.587C428.278 221.158 426.975 220.143 425.546 220.32Z",
    fill: "url(#paint23_linear_991_1197)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M446.754 215.29C444.17 216.21 441.506 217.033 438.808 217.749C437.421 218.112 436.586 219.548 436.956 220.94C437.325 222.332 438.754 223.162 440.146 222.793C441.315 222.483 442.475 222.154 443.624 221.808C445.263 221.313 446.905 220.774 448.503 220.205C449.86 219.722 450.569 218.23 450.086 216.872C449.603 215.515 448.113 214.809 446.754 215.29Z",
    fill: "url(#paint24_linear_991_1197)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M512.467 89.6945C512.021 88.3252 510.557 87.5437 509.179 88.0221C507.809 88.4673 507.06 89.9395 507.506 91.3099C507.732 92.0047 507.952 92.7047 508.164 93.408C508.75 95.3514 509.285 97.3389 509.752 99.3182C510.083 100.72 511.489 101.588 512.89 101.257C512.943 101.244 512.995 101.231 513.046 101.215C514.356 100.82 515.148 99.468 514.829 98.1189C514.337 96.0375 513.775 93.9453 513.159 91.9016C512.935 91.1611 512.705 90.4262 512.467 89.6945Z",
    fill: "url(#paint25_linear_991_1197)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M373.457 211.501C372.184 211.079 370.895 210.623 369.627 210.144C368.278 209.635 366.775 210.316 366.266 211.664C365.757 213.011 366.437 214.516 367.785 215.025C369.12 215.529 370.477 216.01 371.817 216.454C372.346 216.628 372.892 216.624 373.388 216.475C374.173 216.238 374.836 215.635 375.113 214.796C375.566 213.428 374.824 211.953 373.457 211.501Z",
    fill: "url(#paint26_linear_991_1197)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M489.97 95.859L475.286 93.7887C472.477 87.5343 468.726 81.8745 464.255 76.9297L445.302 80.5721L430.818 96.2769L443.604 123.963L411.242 122.882L392.326 136.966L394.894 161.82L375.002 157.963L368.23 164.679L364.409 178.968C364.274 179.47 364.473 180.003 364.905 180.294L379.66 190.246C380.092 190.537 380.66 190.522 381.075 190.21L392.93 181.285C399.407 183.747 406.324 185.195 413.45 185.466L420.87 198.305C421.13 198.756 421.648 198.991 422.159 198.892L439.63 195.496C440.141 195.396 440.532 194.984 440.605 194.469L442.675 179.786C449.181 176.864 455.051 172.931 460.134 168.221L474.469 172.055C474.971 172.189 475.503 171.99 475.794 171.559L485.747 156.803C486.038 156.371 486.023 155.803 485.71 155.388L476.785 143.533C479.248 137.056 480.696 130.14 480.967 123.013L493.806 115.593C494.256 115.333 494.492 114.816 494.393 114.305L490.997 96.8331C490.897 96.3229 490.485 95.9314 489.97 95.859Z",
    fill: "url(#paint27_linear_991_1197)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M421.816 132.897C415.537 135.849 408.144 133.598 404.477 127.926L401.128 130.425C405.479 136.932 413.637 139.877 421.138 137.615C421.965 137.365 422.786 137.052 423.591 136.674C429.022 134.121 432.569 129.169 433.574 123.673L429.339 123.522C428.43 127.497 425.783 131.033 421.816 132.897Z",
    fill: "url(#paint28_linear_991_1197)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M458.263 107.362C455.464 98.0897 449.728 90.0814 441.776 84.395L440.35 85.9417C448.034 91.3672 453.575 99.0543 456.265 107.969C456.678 109.337 457.024 110.734 457.301 112.155C458.877 120.262 457.99 128.287 455.165 135.454C450.085 148.34 438.739 158.454 424.162 161.286C421.228 161.857 418.237 162.116 415.273 162.056C414.697 162.045 414.22 162.501 414.208 163.077C414.206 163.19 414.221 163.299 414.252 163.401C414.38 163.822 414.767 164.133 415.23 164.142C415.406 164.145 415.583 164.05 415.759 164.051C415.85 164.052 415.941 163.955 416.031 163.955C416.063 163.955 416.095 163.955 416.127 163.955C418.47 163.955 420.823 163.863 423.149 163.487C423.621 163.411 424.092 163.377 424.561 163.285C426.051 162.996 427.516 162.657 428.949 162.225C438.615 159.309 446.916 153.221 452.637 144.739C459.208 134.997 461.591 123.286 459.349 111.75C459.059 110.258 458.696 108.798 458.263 107.362Z",
    fill: "url(#paint29_linear_991_1197)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M379.734 150.525L377.287 126.843L396.203 112.759L427.733 113.813C428.115 113.826 428.377 113.431 428.216 113.084L415.779 86.1545L430.264 70.4498L449.216 66.8073C449.037 66.6088 448.864 66.4038 448.682 66.2075L452.516 51.8724C452.651 51.3702 452.452 50.838 452.021 50.5473L437.264 40.5944C436.833 40.3033 436.265 40.3182 435.85 40.631L423.995 49.5561C417.518 47.0931 410.601 45.6456 403.475 45.374L396.055 32.535C395.794 32.0847 395.277 31.8491 394.766 31.9482L377.295 35.3447C376.784 35.444 376.393 35.8563 376.32 36.3714L374.25 51.0551C367.745 53.9763 361.874 57.9097 356.791 62.6198L342.457 58.7857C341.954 58.6511 341.422 58.8505 341.131 59.2817L331.178 74.0377C330.887 74.4689 330.902 75.0369 331.215 75.4522L340.14 87.3068C337.677 93.784 336.229 100.701 335.958 107.827L323.119 115.247C322.668 115.507 322.433 116.025 322.532 116.535L325.929 134.007C326.028 134.517 326.44 134.909 326.956 134.982L341.639 137.052C344.56 143.557 348.494 149.428 353.204 154.511L353.191 154.556L359.963 147.84L378.697 151.473C379.274 151.585 379.794 151.108 379.734 150.525Z",
    fill: "url(#paint30_linear_991_1197)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M389.439 117.804C389.107 117.291 388.795 116.76 388.528 116.192C385.312 109.347 388.264 101.16 395.109 97.9438C395.73 97.6521 396.364 97.4098 397.009 97.2153C399.81 96.3707 402.796 96.445 405.597 97.4551C409.044 98.6983 411.8 101.209 413.359 104.525C414.711 107.404 414.961 110.516 414.301 113.4L418.536 113.55C419.183 110.011 418.779 106.247 417.135 102.75C415.103 98.4246 411.508 95.1497 407.013 93.5288C402.518 91.9075 397.66 92.133 393.335 94.1667C384.407 98.3624 380.556 109.039 384.751 117.968C385.14 118.794 385.597 119.565 386.089 120.302L389.439 117.804Z",
    fill: "url(#paint31_linear_991_1197)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M425.726 73.5588C415.985 66.9878 404.268 64.6035 392.733 66.8459C368.929 71.4736 353.316 94.6113 357.945 118.424C358.231 119.891 358.589 121.339 359.018 122.761C360.879 128.926 364.068 134.614 368.376 139.408C368.762 139.838 369.42 139.871 369.85 139.487C370.161 139.208 370.264 138.784 370.151 138.409C370.109 138.267 370.035 138.132 369.929 138.014C365.825 133.448 362.788 128.029 361.016 122.158C360.607 120.803 360.265 119.423 359.993 118.025C355.584 95.3447 370.441 73.3081 393.132 68.8947C404.119 66.7589 415.28 69.0297 424.56 75.2889C424.814 75.4608 425.06 75.6422 425.311 75.8189L426.737 74.2722C426.402 74.0326 426.069 73.7902 425.726 73.5588Z",
    fill: "url(#paint32_linear_991_1197)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.325 108.841C137.362 88.8038 137.362 56.3173 117.325 36.2803C97.2882 16.2432 64.8017 16.2432 44.7647 36.2803C24.7276 56.3173 24.7276 88.8038 44.7647 108.841C64.8017 128.878 97.2882 128.878 117.325 108.841Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0468 122.163C108.442 122.163 130.649 99.9552 130.649 72.5605C130.649 45.1658 108.442 22.958 81.0468 22.958C53.6521 22.958 31.4443 45.1658 31.4443 72.5605C31.4443 99.9552 53.6521 122.163 81.0468 122.163Z",
    fill: "url(#paint33_linear_991_1197)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M121.949 52.4796C122.029 52.4796 122.109 52.4618 122.185 52.4232C122.444 52.2926 122.547 51.9774 122.417 51.7195C114.486 36.008 98.6345 26.2476 81.0473 26.2476C78.2426 26.2476 75.4318 26.5003 72.693 26.9999C72.4083 27.0516 72.2194 27.3243 72.2713 27.6094C72.3231 27.8945 72.5949 28.0848 72.8809 28.0306C75.5578 27.5428 78.3053 27.2957 81.0473 27.2957C98.2366 27.2957 113.73 36.8354 121.481 52.1912C121.573 52.3741 121.758 52.4796 121.949 52.4796Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M109.65 103.327C126.045 86.9319 126.045 60.3503 109.65 43.9553C93.2551 27.5603 66.6736 27.5603 50.2786 43.9553C33.8836 60.3503 33.8836 86.9319 50.2786 103.327C66.6736 119.722 93.2552 119.722 109.65 103.327Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5642 81.8047L77.813 81.6911C76.4886 81.6595 75.3932 80.5271 75.3238 79.1942L73.5845 45.7215C73.5485 45.0315 73.7966 44.4628 74.27 43.9961C74.7429 43.5298 75.399 43.3797 76.084 43.4274L84.2664 43.9972C84.9369 44.044 85.5771 44.2663 86.0372 44.7905C86.497 45.3137 86.7373 45.9416 86.7026 46.6161L85.0104 79.4791C84.9427 80.7931 83.8692 81.8358 82.5642 81.8047Z",
    fill: "#DA361A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M75.232 89.981C76.4183 88.848 78.0876 88.2998 80.234 88.334C82.4465 88.3693 84.1237 88.9526 85.2719 90.0816C86.4172 91.2074 86.9885 92.8525 86.9885 95.0194C86.9885 97.1087 86.4047 98.7252 85.2337 99.8714C84.0598 101.021 82.395 101.597 80.2338 101.597C78.1132 101.597 76.4507 101.003 75.2513 99.8114C74.0489 98.6168 73.4463 96.9826 73.4463 94.9114C73.4465 92.7616 74.0425 91.1172 75.232 89.981Z",
    fill: "#DA361A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M268.344 50.21L135.895 272.756C132.987 277.642 136.788 283.62 142.834 283.67L405.389 285.831C411.457 285.88 415.372 279.926 412.515 274.992L282.409 50.2846C279.418 45.1187 271.4 45.0761 268.344 50.21Z",
    fill: "url(#paint34_linear_991_1197)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M269.014 63.5048L148.723 265.621C146.082 270.058 149.534 275.487 155.025 275.532L393.477 277.495C398.988 277.54 402.543 272.132 399.948 267.651L281.787 63.5725C279.07 58.881 271.789 58.8422 269.014 63.5048Z",
    fill: "url(#paint35_linear_991_1197)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M248.338 202L242.46 202.076V212.57L232.32 212.739V202.208L211.136 202.483V194.955L232.892 161.926L242.46 161.936V193.765L248.338 193.705V202ZM232.32 193.867V185.247C232.32 183.81 232.375 181.725 232.488 178.99C232.6 176.256 232.69 174.668 232.757 174.227L232.488 174.228C231.656 176.132 230.655 177.99 229.486 179.805L220.408 193.987L232.32 193.867Z",
    fill: "url(#paint36_linear_991_1197)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M287.096 186.905C287.096 195.61 285.739 202.071 283.022 206.295C280.299 210.527 276.095 212.694 270.398 212.79C264.854 212.884 260.659 210.775 257.826 206.458C254.988 202.132 253.566 195.699 253.566 187.167C253.566 178.266 254.949 171.702 257.71 167.481C260.466 163.269 264.7 161.169 270.398 161.177C275.921 161.185 280.081 163.378 282.891 167.75C285.697 172.113 287.096 178.496 287.096 186.905ZM263.723 187.087C263.723 193.252 264.233 197.663 265.254 200.32C266.274 202.974 267.99 204.284 270.398 204.25C272.758 204.218 274.46 202.847 275.507 200.14C276.553 197.436 277.075 193.05 277.075 186.983C277.075 180.848 276.547 176.442 275.491 173.764C274.433 171.085 272.736 169.747 270.398 169.751C268.012 169.755 266.302 171.103 265.271 173.796C264.239 176.492 263.723 180.923 263.723 187.087Z",
    fill: "url(#paint37_linear_991_1197)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M327.399 200.971L321.844 201.044V211.245L312.261 211.405V201.168L292.248 201.429V194.112L312.802 162.011L321.844 162.021V192.963L327.399 192.907V200.971ZM312.261 193.06V184.681C312.261 183.285 312.314 181.257 312.42 178.599C312.526 175.941 312.611 174.398 312.675 173.97L312.42 173.971C311.634 175.821 310.689 177.627 309.583 179.391L301.007 193.174L312.261 193.06Z",
    fill: "url(#paint38_linear_991_1197)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M225.456 256.961L209.812 257.463V229.513L225.456 229.163V233.993L215.592 234.23V240.354L224.772 240.114V244.944L215.592 245.2V252.393L225.456 252.094V256.961Z",
    fill: "url(#paint39_linear_991_1197)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M237.715 245.947V256.568L232.023 256.751V229.016L239.839 228.841C243.468 228.76 246.148 229.383 247.884 230.709C249.617 232.033 250.482 234.082 250.482 236.859C250.482 238.48 250.053 239.933 249.193 241.219C248.332 242.506 247.113 243.529 245.535 244.291C249.538 250.376 252.14 254.297 253.349 256.067L247.101 256.267L240.735 245.861L237.715 245.947ZM237.715 241.177L239.546 241.128C241.338 241.08 242.659 240.736 243.511 240.096C244.362 239.457 244.788 238.476 244.788 237.154C244.788 235.845 244.353 234.924 243.483 234.391C242.613 233.858 241.265 233.613 239.436 233.657L237.715 233.698L237.715 241.177Z",
    fill: "url(#paint40_linear_991_1197)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M263.195 245.225V255.752L257.604 255.931V228.445L265.281 228.273C268.846 228.193 271.479 228.811 273.183 230.125C274.886 231.438 275.736 233.469 275.736 236.221C275.736 237.828 275.314 239.268 274.469 240.542C273.624 241.817 272.426 242.832 270.876 243.586C274.808 249.618 277.364 253.505 278.552 255.26L272.415 255.456L266.161 245.141L263.195 245.225ZM263.195 240.498L264.993 240.45C266.753 240.403 268.051 240.062 268.888 239.428C269.724 238.794 270.142 237.823 270.142 236.512C270.142 235.215 269.715 234.302 268.861 233.774C268.006 233.245 266.682 233.002 264.885 233.045L263.195 233.086V240.498Z",
    fill: "url(#paint41_linear_991_1197)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M306.089 240.831C306.089 245.303 305.041 248.772 302.944 251.239C300.843 253.712 297.826 255.012 293.887 255.138C289.938 255.265 286.897 254.154 284.772 251.801C282.644 249.444 281.578 245.997 281.578 241.46C281.578 236.924 282.646 233.434 284.781 230.992C286.911 228.554 289.961 227.293 293.922 227.205C297.873 227.117 300.887 228.247 302.97 230.593C305.05 232.935 306.089 236.347 306.089 240.831ZM287.339 241.341C287.339 244.38 287.888 246.652 288.984 248.157C290.079 249.661 291.713 250.379 293.887 250.313C298.235 250.18 300.405 247.072 300.405 240.986C300.405 234.888 298.247 231.89 293.922 231.993C291.749 232.045 290.108 232.856 289.001 234.426C287.893 235.997 287.339 238.302 287.339 241.341Z",
    fill: "url(#paint42_linear_991_1197)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M317.635 243.683V254.007L312.258 254.179V227.222L319.642 227.057C323.071 226.98 325.604 227.587 327.244 228.877C328.881 230.165 329.7 232.158 329.7 234.857C329.7 236.433 329.293 237.845 328.481 239.095C327.667 240.345 326.516 241.339 325.024 242.078C328.807 247.997 331.266 251.811 332.408 253.533L326.504 253.722L320.488 243.601L317.635 243.683ZM317.635 239.045L319.365 238.999C321.058 238.954 322.306 238.621 323.111 238C323.916 237.378 324.318 236.426 324.318 235.14C324.318 233.868 323.907 232.972 323.085 232.454C322.263 231.935 320.989 231.696 319.261 231.737L317.635 231.776L317.635 239.045Z",
    fill: "url(#paint43_linear_991_1197)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M111.591 489.907C111.591 489.907 110.273 497.37 109.627 504.756C109.374 507.644 111.6 510.15 114.496 510.271C124.333 510.68 145.375 511.477 152.926 511.14C154.061 511.09 154.803 509.928 154.383 508.872C154.031 507.987 153.352 507.272 152.487 506.874L117.729 490.9L111.591 489.907Z",
    fill: "url(#paint44_linear_991_1197)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M110.512 485.522L111.571 494.448C111.571 494.448 117.659 497.283 121.818 494.091L119.296 484.144L110.512 485.522Z",
    fill: "url(#paint45_linear_991_1197)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M111.308 317.711C110.85 320.042 108.852 434.032 121.037 485.114C121.236 485.948 120.813 486.807 120.02 487.131C118.151 487.895 114.487 489.001 110.097 489.148C108.737 489.194 107.518 488.31 107.134 487.005C103.651 475.153 86.9614 415.771 84.7843 359.045C82.3516 295.66 84.7843 356.887 84.7843 356.887L86.2111 317.706L111.308 317.711Z",
    fill: "url(#paint46_linear_991_1197)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6092 493.801C71.6092 493.801 69.5109 497.568 67.4795 507.579C67.1127 509.387 68.3758 511.117 70.2117 511.297C73.4599 511.617 78.4606 512.027 82.4662 512C84.3127 511.987 85.7538 510.379 85.5311 508.546C85.0876 504.892 83.7052 498.897 79.435 494.225L71.6092 493.801Z",
    fill: "url(#paint47_linear_991_1197)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7656 482.319L72.2402 495.818C72.2402 495.818 74.6869 497.638 79.5271 496.319L78.346 481.795L69.7656 482.319Z",
    fill: "url(#paint48_linear_991_1197)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0805 321.209C53.115 381.351 65.2421 469.855 69.3321 487.178C69.5825 488.238 70.4385 489.051 71.5134 489.229C73.339 489.532 76.3448 489.779 79.3079 488.918C80.329 488.621 81.0462 487.7 81.0879 486.638C81.6366 472.633 80.649 386.659 89.9344 352.681C90.4049 350.959 91.4565 349.457 92.9115 348.423L110.934 335.611L112.316 314.9L63.0805 321.209Z",
    fill: "url(#paint49_linear_991_1197)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M151.804 235.48C150.289 246.254 148.69 248.73 147.447 248.794C143.492 248.998 144.289 224.707 129.825 212.42C120.689 204.659 108.21 204.02 98.4189 204.925C102.987 221.308 107.555 237.692 112.124 254.076C114.119 258.971 122.816 278.769 142.495 284.778C146.502 286.001 152.465 287.822 158.011 285.438C168.959 280.733 174.092 261.45 169.198 237.306C166.896 236.451 163.711 235.541 151.804 235.48Z",
    fill: "url(#paint50_linear_991_1197)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M148.316 193.465L150.128 203.704C153.037 216.227 153.314 226.666 151.804 235.48C154.304 235.583 156.928 235.759 159.662 236.029C163.034 236.361 166.218 236.801 169.198 237.306C167.624 224.569 159.149 203.42 159.149 203.42C154.037 196.041 153.428 200.843 148.316 193.465Z",
    fill: "url(#paint51_linear_991_1197)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M169.021 171.889C166.97 171.835 165.005 172.717 163.681 174.285L150.763 189.592C150.763 189.592 148.412 189.112 148.191 184.609C147.971 180.107 143.188 179.565 143.188 179.565C143.188 179.565 143.878 185.844 145.191 195.137C145.942 200.452 149.084 204.331 151.637 206.681L159.11 204.109C165.965 194.31 170.22 183.51 172.586 171.983L169.021 171.889Z",
    fill: "url(#paint52_linear_991_1197)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2695 213.533C48.1307 213.307 54.0144 207.228 54.8988 207.059C69.4008 204.295 105.598 194.546 129.825 212.419C129.885 212.935 129.924 213.347 129.947 213.688C130.182 214.007 130.505 214.542 130.946 215.399C133.234 219.833 135.98 224.142 139.123 228.168C138.431 228.854 137.857 229.66 137.438 230.557C131.617 243.027 109.549 292.828 113.427 323.282C113.628 324.855 112.557 326.304 110.987 326.522C102.42 327.706 76.9088 330.596 63.7286 325.153C62.9616 324.836 62.471 324.084 62.4829 323.254C62.5695 317.144 62.3111 290.625 52.5889 258.658C52.2267 257.467 51.9312 256.257 51.6947 255.035C51.5748 255.281 51.4624 255.524 51.3463 255.769L47.2695 213.533Z",
    fill: "url(#paint53_linear_991_1197)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4015 204.295C42.3573 206.273 36.7057 221.727 18.0156 212.278L21.3251 241.219C28.2556 248.873 38.7192 254.086 51.9043 256.039L69.4015 204.295Z",
    fill: "url(#paint54_linear_991_1197)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8801 178.121C83.2462 187.358 81.3118 196.766 80.7314 205.526C81.7281 205.897 95.0285 215.124 103.931 206.193C102.028 200.064 102.343 190.836 102.827 181.371L87.8801 178.121Z",
    fill: "url(#paint55_linear_991_1197)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M112.009 153.836C112.264 154.249 118.91 185.595 118.91 185.595L100.932 189.009L90.2178 160.236C90.2178 160.236 107.743 146.934 112.009 153.836Z",
    fill: "url(#paint56_linear_991_1197)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0812 162.794C96.6002 163.452 96.4501 164.291 96.6741 165.075L101.063 180.438C101.13 180.671 101.225 180.891 101.353 181.097C102.062 182.23 104.61 185.655 108.044 182.842C110.971 180.445 113.694 178.282 116.134 177.743C117.56 177.429 118.96 178.361 119.257 179.79C119.87 182.733 120.986 188.697 121.234 194.135C121.296 195.498 120.286 196.673 118.931 196.84C115.358 197.281 108.354 197.934 102.492 197.198C101.529 197.077 100.715 196.439 100.366 195.534C98.8272 191.55 94.4699 180.4 92.7554 177.442C91.1627 174.694 86.9322 174.434 84.9855 174.469C84.2464 174.482 83.5412 174.191 83.0285 173.659C81.4908 172.062 79.0284 168.454 83.2052 164.581C84.2437 163.619 84.2863 161.977 83.3451 160.919C81.6589 159.023 80.1151 155.899 83.33 152.372C86.5845 148.802 90.511 149.457 93.0318 150.474C94.1471 150.925 95.4802 150.634 96.2107 149.678C96.5356 149.253 97.0339 148.95 97.7976 148.998C99.2378 149.087 100.47 148.078 100.568 146.639C100.738 144.17 101.901 141.216 106.198 140.162C114.079 138.228 118.445 145.994 118.581 151.598C118.718 157.202 110.054 158.813 105.06 158.13C101.391 157.629 98.4069 160.979 97.0812 162.794Z",
    fill: "url(#paint57_linear_991_1197)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4495 183.27C95.4495 183.27 93.7766 173.347 89.7793 172.626C85.7819 171.906 81.6608 174.975 85.3314 180.652C89.8972 187.714 95.4495 183.27 95.4495 183.27Z",
    fill: "url(#paint58_linear_991_1197)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8557 147.569C89.5529 147.54 90.3098 147.607 91.1444 147.783C93.0447 148.186 95.5764 149.163 94.9171 150.991C93.9268 153.736 88.7893 151.171 86.0538 155.596C83.6435 159.496 85.6164 163.731 84.8787 167.934C84.5197 169.978 83.2061 173.014 81.3798 174.208C80.563 174.742 74.1129 175.764 73.7601 174.619C73.7601 174.619 71.9678 168.802 71.9673 168.8C70.3547 163.567 76.5505 154.847 79.7461 151.321C82.2151 148.597 85.561 147.704 88.8557 147.569Z",
    fill: "url(#paint59_linear_991_1197)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7417 168.573L76.5717 173.709C64.7405 178.741 56.1449 184.67 49.9156 191.086C47.6601 186.843 44.0087 181.938 38.1875 178.112C50.1134 172.237 58.9912 169.797 58.9912 169.797C83.0595 160.117 82.7417 168.573 82.7417 168.573Z",
    fill: "url(#paint60_linear_991_1197)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9151 191.086C30.4642 211.117 36.148 200.938 35.9933 218.011C35.9357 224.377 30.4114 248.684 30.4114 248.684C-29.0747 222.986 20.5677 187.909 38.187 178.112C44.0082 181.938 47.6596 186.843 49.9151 191.086Z",
    fill: "url(#paint61_linear_991_1197)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_991_1197",
    x1: 578.353,
    y1: 662.996,
    x2: 122.327,
    y2: 96.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_991_1197",
    x1: 297.125,
    y1: 361.319,
    x2: 386.294,
    y2: 170.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_991_1197",
    x1: 258.457,
    y1: 16.9612,
    x2: 258.457,
    y2: 218.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_991_1197",
    x1: 314.693,
    y1: 692.435,
    x2: 283.732,
    y2: 541.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_991_1197",
    x1: 419.797,
    y1: -52.3015,
    x2: 388.844,
    y2: 296.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_991_1197",
    x1: 340.755,
    y1: -59.3254,
    x2: 309.803,
    y2: 288.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_991_1197",
    x1: 318.449,
    y1: -61.3093,
    x2: 287.497,
    y2: 286.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_991_1197",
    x1: 328.671,
    y1: -60.3998,
    x2: 297.719,
    y2: 287.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_991_1197",
    x1: 397.318,
    y1: -54.2968,
    x2: 366.366,
    y2: 293.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_991_1197",
    x1: 321.115,
    y1: -61.0723,
    x2: 290.163,
    y2: 287.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_991_1197",
    x1: 320.951,
    y1: -61.0879,
    x2: 289.998,
    y2: 287.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_991_1197",
    x1: 356.77,
    y1: -57.902,
    x2: 325.818,
    y2: 290.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_991_1197",
    x1: 375.952,
    y1: -56.1964,
    x2: 345,
    y2: 292.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_991_1197",
    x1: 328.315,
    y1: -60.4339,
    x2: 297.362,
    y2: 287.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_991_1197",
    x1: 440.163,
    y1: -50.4912,
    x2: 409.21,
    y2: 297.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_991_1197",
    x1: 414.419,
    y1: -52.7869,
    x2: 383.466,
    y2: 295.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_991_1197",
    x1: 514.155,
    y1: -40.1345,
    x2: 483.203,
    y2: 308.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_991_1197",
    x1: 528.613,
    y1: -38.8493,
    x2: 497.661,
    y2: 309.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_991_1197",
    x1: 529.333,
    y1: -38.7847,
    x2: 498.381,
    y2: 309.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_991_1197",
    x1: 516.282,
    y1: -39.9437,
    x2: 485.33,
    y2: 308.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_991_1197",
    x1: 486.489,
    y1: -42.5894,
    x2: 455.537,
    y2: 305.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_991_1197",
    x1: 503.192,
    y1: -41.1069,
    x2: 472.24,
    y2: 307.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_991_1197",
    x1: 525.143,
    y1: -39.1568,
    x2: 494.19,
    y2: 309.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_991_1197",
    x1: 445.562,
    y1: -46.2247,
    x2: 414.61,
    y2: 302.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_991_1197",
    x1: 466.955,
    y1: -44.3248,
    x2: 436.003,
    y2: 303.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_991_1197",
    x1: 523.042,
    y1: -39.345,
    x2: 492.09,
    y2: 308.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_991_1197",
    x1: 394.473,
    y1: -54.5558,
    x2: 363.52,
    y2: 293.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_991_1197",
    x1: 261.283,
    y1: 674.678,
    x2: 315.054,
    y2: 507.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_991_1197",
    x1: 401.128,
    y1: 130.946,
    x2: 433.574,
    y2: 130.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_991_1197",
    x1: 414.208,
    y1: 124.268,
    x2: 460.171,
    y2: 124.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_991_1197",
    x1: 201.529,
    y1: 655.411,
    x2: 255.301,
    y2: 488.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_991_1197",
    x1: 383.054,
    y1: 106.38,
    x2: 418.829,
    y2: 106.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_991_1197",
    x1: 357.132,
    y1: 102.889,
    x2: 426.737,
    y2: 102.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_991_1197",
    x1: 113.099,
    y1: -52.1466,
    x2: 66.5771,
    y2: 128.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_991_1197",
    x1: 234.611,
    y1: 53.4475,
    x2: 279.631,
    y2: 308.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_991_1197",
    x1: 353.248,
    y1: 87.01,
    x2: 120.286,
    y2: 626.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_991_1197",
    x1: 208.408,
    y1: 250.339,
    x2: 327.379,
    y2: -38.9484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_991_1197",
    x1: 239.074,
    y1: 262.951,
    x2: 358.045,
    y2: -26.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_991_1197",
    x1: 276.58,
    y1: 278.375,
    x2: 395.551,
    y2: -10.9127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_991_1197",
    x1: 213.801,
    y1: 252.557,
    x2: 332.772,
    y2: -36.7305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_991_1197",
    x1: 234.984,
    y1: 261.269,
    x2: 353.956,
    y2: -28.0192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_991_1197",
    x1: 256.46,
    y1: 270.101,
    x2: 375.432,
    y2: -19.1871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_991_1197",
    x1: 278.239,
    y1: 279.058,
    x2: 397.209,
    y2: -10.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_991_1197",
    x1: 302.348,
    y1: 288.973,
    x2: 421.32,
    y2: -0.315941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_991_1197",
    x1: 151.826,
    y1: 479.594,
    x2: 24.5433,
    y2: 618.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_991_1197",
    x1: 110.512,
    y1: 489.876,
    x2: 121.818,
    y2: 489.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_991_1197",
    x1: -559.007,
    y1: 1178.6,
    x2: -437.137,
    y2: 1035.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_991_1197",
    x1: 123.273,
    y1: 453.343,
    x2: -4.0097,
    y2: 591.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_991_1197",
    x1: 69.7657,
    y1: 489.297,
    x2: 79.5272,
    y2: 489.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_991_1197",
    x1: -576.092,
    y1: 1164.02,
    x2: -454.223,
    y2: 1021.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_991_1197",
    x1: 151.026,
    y1: 189.118,
    x2: 107.061,
    y2: 312.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_991_1197",
    x1: 110.214,
    y1: 151.661,
    x2: 224.554,
    y2: 322.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_991_1197",
    x1: 128.435,
    y1: 139.495,
    x2: 242.775,
    y2: 310.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_991_1197",
    x1: 113.407,
    y1: 175.763,
    x2: 69.4411,
    y2: 299.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_991_1197",
    x1: 62.1504,
    y1: 157.566,
    x2: 18.1849,
    y2: 281.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_991_1197",
    x1: 104.962,
    y1: 175.156,
    x2: 59.4789,
    y2: 260.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_991_1197",
    x1: 43.2676,
    y1: 163.067,
    x2: 131.242,
    y2: 173.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_991_1197",
    x1: 88.2422,
    y1: 182.503,
    x2: 125.595,
    y2: 159.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_991_1197",
    x1: 42.0951,
    y1: 172.836,
    x2: 130.07,
    y2: 183.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_991_1197",
    x1: 93.7829,
    y1: 153.622,
    x2: 22.8037,
    y2: 201.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_991_1197",
    x1: 92.3637,
    y1: 152.193,
    x2: 18.5253,
    y2: 202.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_991_1197",
    x1: 44.8861,
    y1: 151.439,
    x2: 0.920621,
    y2: 275.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagenotfound);
export default __webpack_public_path__ + "static/media/pagenotfound.b80c6c834764ae925b8425a3610b9ae1.svg";
export { ForwardRef as ReactComponent };